<template>
<loading-overlay :active="isLoading" :is-full-page="true" :width="128" :height="128" loader="spinner" color="rgb(var(--color-active-hsl-128))" background-color="rgb(var(--color-b-back))" />
  <SrcBackgroundScroll @scrolled="isShrunk = $event">
      <HeadlineSubScroll 
          :title="$t('setmesh.rfidsecurity')" 
          target="/Settings" 
          :hassubline="!isShrunk"
          :hasmenu="false"
          :isShrunk="isShrunk"
          >
            <template #icon>
              <IconSecurity             
                class="transition-all duration-300"
                :class="isShrunk ? 'w-8 h-8' : 'w-12 h-12'"/>
            </template>
            <template #subline>
              {{ $t('settings.meshsubtext') }}
            </template>
      </HeadlineSubScroll>

      <ConfirmLeaveModal
        v-model:show="showLeaveDialog"
        :pendingNavigation="this.leaveDialog"
      />

    <SettingsHeader :admin="this.$store.state.Role=='admin'">
      {{ $t('settings.meshsubtext') }}
    </SettingsHeader>

    <SettingsBody>
        <template v-slot:formgrid>
            <!--          
          <div class="form-group mt-4 mb-2">
            <ToggleWithLabel 
              v-model="freecharge"
              :label="$t('setgeneral.freecharging')"
              :ontext="$t('common.on')"
              :offtext="$t('common.off')"
            />
          </div>   
          <div class="form-group mt-4 mb-2">
            <ToggleWithLabel 
              v-model="deauth"
              :disabled="freecharge"
              :label="$t('setgeneral.stopcharging')"
              :ontext="$t('common.yes')"
              :offtext="$t('common.no')"
            />
          </div>
          <div class="form-group mb-2 sm:col-span-2">
            <div class="border-b border-b-4 py-2 font-bold text-lg border-skin-b-list-bord">{{ $t('setmesh.rfidsecurity') }}</div>           
          </div>
          -->
          <div class="form-group mt-4 mb-2 sm:col-span-2">
            <ToggleWithLabel 
              v-model="rfidencryption"
              :label="$t('setmesh.rfidencryption')"
              :ontext="$t('common.on')"
              :offtext="$t('common.off')"
              @update:modelValue ="onChange"

            />
          </div>
          <div class="form-group mt-4 mb-2 sm:col-span-2">
            <ToggleWithLabel 
              v-model="rfidencryptiononly"
              :disabled="!rfidencryption"
              :label="$t('setmesh.rfidencryptiononly')"
              :ontext="$t('common.yes')"
              :offtext="$t('common.no')"
              @update:modelValue ="onChange"
            />
          </div>
          <div class="w-full form-group mb-4">
            <label class="font-medium text-sm text-skin-b-list-mute" for="">
              {{ $t('setmesh.rfidencryptionafter') }}
            </label>
              <SelectWithLabelIcon
                v-model="rfidencryptionafter"
                :disabled="!rfidencryption"      
                @update:modelValue ="onChange"
              >
              <template v-slot:options>
                <option value="0">{{ $t('setmesh.rfidencryptionafterno') }}</option>
                <option value="1">{{ $t('setmesh.rfidencryptionafteryes') }}</option>
              </template>
              </SelectWithLabelIcon>
          </div>
        </template>
        <template v-slot:formbottom>

          <div class="w-full mt-6">
            <ActionButton :disabled="!isDirty" @click="saveGeneral()">
              {{ $t('common.save') }}
            </ActionButton>
          </div>

        </template>
    </SettingsBody>
  </SrcBackgroundScroll>
</template>

<script>
import SrcBackgroundScroll from './sources/SrcBackgroundScroll.vue'
import HeadlineSubScroll from './elements/HeadlineSubScroll.vue'
import IconSecurity from './icons/IconSecurity.vue'
import SettingsHeader from './elements/SettingsHeader.vue'
import SettingsBody from './elements/SettingsBody.vue'
import ActionButton from './elements/ActionButton.vue'
//import InputLabelError from './elements/InputLabelError.vue'
//import TextfieldWithLabel from './elements/TextfieldWithLabel.vue'
import ToggleWithLabel from './elements/ToggleWithLabel.vue'
import SelectWithLabelIcon from './elements/SelectWithLabelIcon.vue'
import ConfirmLeaveModal from './elements/ConfirmLeaveModal.vue'
import { useI18n } from 'vue-i18n'

export default {
  setup () {
    const { t,d,n } = useI18n()
    return { t,d,n }
  }, 
  components: {
    SrcBackgroundScroll, HeadlineSubScroll, IconSecurity,
    SettingsHeader, SettingsBody, ActionButton, ToggleWithLabel, SelectWithLabelIcon, ConfirmLeaveModal
  },
  data() {
    return {
          isLoading: false,
          rfidencryption: true,
          rfidencryptiononly: true,
          rfidencryptionafter: 0,
          saveto: this.$store.state.WbId,
          freecharge: false,
          deauth: false,
          currentSettings: [],
          meshSetting: [],
          isShrunk: false,

          isDirty:false,
          showLeaveDialog:false
    }
  },
  beforeRouteLeave(to, from, next) {

    if (this.isDirty || this.editmode) {
      this.showLeaveDialog = true;
      this.pendingNavigation = next;    
    } else {
      next();
    }
  },

  computed: {
  },
  methods: {
    onChange() {this.isDirty = true;},
    leaveDialog(){this.pendingNavigation();},

    decodeHtml: function(html) {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
      },
    saveGeneral() {
      this.isLoading = true;
      this.currentSettings.freeCharging = this.freecharge ? '1' : '0';
      this.currentSettings.stopChargingWithTag = this.deauth ? '1' : '0';

      let rfidencryptiontemp = this.rfidencryption ? 'aes' : 'off';
      let rfidencryptiononlytemp = this.rfidencryptiononly ? '1' : '0';

      const urls = [
        //`wallbox/settings.php?action=sync_max_current&client=${this.saveto}&freeCharging=${this.currentSettings.freeCharging}&user=${this.$store.state.token}`,
        //`wallbox/settings.php?action=sync_deauth&client=${this.saveto}&stopChargingWithTag=${this.currentSettings.stopChargingWithTag}&user=${this.$store.state.token}`,
        `wallbox/mesh.php?action=mesh_update_rfid_security&rfid_enc=${rfidencryptiontemp}&rfid_enc_only=${rfidencryptiononlytemp}&rfid_enc_subsequent=${this.rfidencryptionafter}&user=${this.$store.state.token}`
      ];

      //let results = null;

      Promise.all(urls.map(url => this.axios.get(url)))
        //.then(responses => {
          //results = responses;
        //})
        .catch(error => {
          console.error('One or more requests failed:', error);
        })
        .finally(() => {
          this.updatePage();
        });

        this.isDirty=false;

    },
    async syncMesh() {
      if (!this.$store.state.token) {
        this.$router.push({ path: '/' });
        return;
      }
      this.isLoading = true;
      try {
        const response = await this.axios.get(
          `wallbox/mesh.php?action=mesh_sync&user=${this.$store.state.token}`
        );

        switch (response.data.status) {
          case 'token':
            this.$router.push({ path: '/' });
            break;
          case 'ok':
            console.log('Sync mesh settings');
            break;
          default:
            console.log('Error Sync mesh settings');
        }
      } catch (error) {
        console.error('Request failed:', error);
      } finally {
        // Always call updatePage() after the request finishes
        this.updatePage();
      }
    },
    updatePage() {
      this.isLoading = true;

      const client_settingsUrl = `wallbox/info.php?action=get_settings&user=${this.$store.state.token}&client=${this.$store.state.WbId}`;
      const mesh_settingsUrl = `/wallbox/mesh.php?action=mesh_get_settings&user=${this.$store.state.token}&client=${this.$store.state.WbId}`;

      Promise.all([
        this.axios.get(client_settingsUrl),
        this.axios.get(mesh_settingsUrl)
      ])
        .then(([clientRes, meshRes]) => {
          // Handle client settings
          if (clientRes.data.status === 'token') {
            this.$router.push({ path: '/' });
          } else if (clientRes.data.status === 'ok') {
            this.currentSettings = clientRes.data.tbl_settings;
            this.freecharge = this.currentSettings.freeCharging === 1;
            this.deauth = this.currentSettings.stopChargingWithTag === 1;
          } else {
            console.log('Error get Client Settings Table');
          }

          // Handle mesh settings
          if (meshRes.data.status === 'token') {
            this.$router.push({ path: '/' });
          } else if (meshRes.data.status === 'ok') {
            if (meshRes.data.tbl_mesh_settings !== '') {
              this.meshSetting = meshRes.data.tbl_mesh_settings;
              this.rfidencryption = this.meshSetting.rfid_enc === 'aes';
              this.rfidencryptiononly = this.meshSetting.rfid_enc_only === 1;
              this.rfidencryptionafter = this.meshSetting.rfid_enc_subsequent;
            }
          } else {
            console.log('Error get Mesh Settings Table');
          }
        })
        .catch(error => {
          console.error('Failed to load settings:', error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  created() {
      this.updatePage();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
